export { default } from './Separator';
